<template>
  <artmisads-modal
    v-model:open="visible"
    :title="$t('seller.brandsPage.modalAssociatePublishers')"
    :width="1200"
    :maskClosable="false"
    @cancel="handleCancel"
    :footer="null"
  >
    <div class="publisher-modal-content">
     <PublisherAssociateTable
      :brandId="brandId"
    />
    </div>
  </artmisads-modal>
</template>

<script setup>
import { ref } from 'vue';
import PublisherAssociateTable from '@/components/PublisherAssociateTable.vue';

// 内部状态管理
const visible = ref(false);
const brandId = ref('');
const publisherTableRef = ref(null);

// 打开弹窗的方法
const open = (id) => {
  brandId.value = id;
  visible.value = true;
};

// 关闭弹窗
const handleCancel = () => {
  visible.value = false;
  publisherTableRef.value?.resetData();
};

// 事件处理
const handleEdit = (record) => {
  console.log('Edit:', record);
  // TODO: 处理编辑逻辑
};

const handleHistory = (record) => {
  console.log('History:', record);
  // TODO: 处理历史记录逻辑
};

// 暴露方法给父组件
defineExpose({
  open
});
</script>

<style lang="less" scoped>
.publisher-modal-content {
  min-height: 400px;
}
</style>